import React from 'react';
import styled from "styled-components";


const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Siempre tres columnas */
  gap: 20px;
  width: 100%;
  max-width: 1200px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(
      2,
      1fr
    ); /* Dos columnas para pantallas más pequeñas */
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr; /* Una columna para pantallas muy pequeñas */
  }
`;

const Card = styled.div`
  background-color: white;
  border: 1px solid #f7bc0c;
  border: 1px solid red
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: 0.3s;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  }

  h4 {
    color: #041c40;
    margin: 10px 0;
  }

  p {
    color: #777;
    font-size: 14px;
    line-height: 1.6;
  }

  a {
    display: inline-block;
    margin-top: 10px;
    color: #f7bc0c;
    font-weight: bold;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  font-size: 40px;
  color: #f7bc0c;
  margin-bottom: 15px;
`;

const cardData = [
    {
      title: "FINISH CARPENTRY",
      description:
        "Precision-crafted details to elevate your spaces. Our expert carpenters deliver flawless trim work, crown molding, and custom finishes to bring your vision to life.",
        image: "./img/services/service1.jpg",
    },
    {
      title: "ROOFING & SIDING",
      description:
        "Durable and stylish protection for your home. We specialize in roofing and siding solutions that combine functionality with aesthetic appeal, tailored to withstand the elements.",
      image: "./img/services/service2.jpg",
    },
    {
      title: "FRAMING RENOVATIONS",
      description:
        "Building the backbone of your dreams. From structural adjustments to complete framing projects, our team ensures strength and stability for every renovation.",
      image: "./img/services/service3.jpg",
    },
    {
      title: "ADDITIONS",
      description:
        "Expand your living space seamlessly. Whether it's a new room, garage, or sunroom, our additions blend beautifully with your existing home.",
      image: "./img/services/service4.jpg",
    },
    {
      title: "DECKS",
      description:
        "Create your outdoor oasis. From sleek designs to sturdy builds, we construct decks that are perfect for entertaining, relaxing, or enjoying the view.",
      image: "./img/services/service5.jpg",
    },
    {
      title: "OTHER",
      description:
        "Tailored solutions for every unique need. From custom projects to specialized requests, we tackle a wide variety of services with quality craftsmanship.",
      image: "./img/services/service6.jpg",
    },
  ];
  

const CardService = () => {
  return (
    <CardsWrapper>
          {cardData.map((item, i) => (
            <Card>
              <h4 className="d-flex justify-content-center">{item.title}</h4>
              <IconWrapper>
                <img
                  src={item.image}
                  height={300}
                  width={"100%"}
                />
              </IconWrapper>
              <p>
              {item.description}
              </p>
              {/*<a href="#readmore">Read More →</a>*/}
            </Card>
          ))}
        </CardsWrapper>
  )
}

export default CardService;